import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { testimonials } from '../data/salesCopy';
export function Testimonials() {
  return <section className="bg-brand-ivoryLight px-4 py-8 sm:py-10" data-id="element-254" data-mp="3fze2zvj28zum">
      <div className="mx-auto max-w-4xl" data-id="element-255" data-mp="3fxuooagysyvh">
        <SectionTitle data-id="element-256" data-mp="3b147fjtfbx8h">What Yin Yoga Instructors Are Saying</SectionTitle>

        <div className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-257" data-mp="3ayqbl8qx6gzv">
          {testimonials.map((t, i) => <figure key={t.author} className={`flex flex-col rounded-lg border border-brand-sand/70 bg-white p-3 shadow-sm ${i === 0 ? 'sm:col-span-2' : ''}`} data-id="element-258" data-mp="36wmrjvq6q42z" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-259" data-mp="2s2i6q61tk853">
                {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-260" data-mp="qac1axrhk6zc" />)}
              </div>
              <blockquote className="mt-1.5 text-[12.5px] font-medium italic leading-snug text-brand-charcoal/85 sm:text-[13.5px]" data-id="element-261" data-mp="m5b43ntn3sht">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-2 border-t border-brand-sand/50 pt-2.5" data-id="element-262" data-mp="c6bt3ylejkrn">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-clay/15 font-serif text-sm font-extrabold text-brand-clay" aria-hidden="true" data-id="element-263" data-mp="zw64sctzj3ab">
                  {t.author.charAt(0)}
                </span>
                <div className="leading-tight" data-id="element-264" data-mp="v4xwjk4e5nyq">
                  <p className="text-[12.5px] font-extrabold text-brand-charcoal" data-id="element-265" data-mp="v3mt5leuyi85">
                    {t.author}
                  </p>
                  <p className="text-[10.5px] font-semibold uppercase tracking-wide text-brand-taupe" data-id="element-266" data-mp="1nlqt7b8wqsqz">
                    {t.role} — {t.location}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}